import {
    updateStateAfterWidgetOptionChange,
    isMdaeWidgetOptionChangeEvent,
} from "../../../../../common_components/mdae-framework";
import { cloneDeepWith, isEmpty } from 'lodash';
import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";
  import { GET_REMIT_DETAIL } from '../services/get-remit-detail';
import { GET_SELECTED_CASE_PAY_LINES } from "../services/get-selected-case-pay-lines";
  export const TOGGLE_REMIT_DETAIL_POPUP = "TOGGLE_REMIT_DETAIL_POPUP";
  export const SET_EXPAND_COLLAPSE_BUTTON_TITLE = "SET_EXPAND_COLLAPSE_BUTTON_TITLE"; 
  export const SET_REMIT_DETAIL_DATA="SET_REMIT_DETAIL_DATA";
  export const ADD_SELECTED_IDS_FROM_CASE_PAY_LINES = "ADD_SELECTED_IDS_FROM_CASE_PAY_LINES";

  export const expandcollapseTitles ={
    EXPAND_ALL : "Expand All",
    COLLAPSE_ALL : "Collapse All"
  }
  
export const getNumber = (value) => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    let cleaned = value.replace(/[$,]/g, '').trim();
    const parsed = Number(cleaned);
    if (isNaN(parsed)) return 0;
    return parsed;
  }
  return 0;
}
  const initalRemitData = {
    remitData: {
      extraFields: {},
      medicareAdjudication: {},
      linelevelAdjustmentList:[]
    },
  }

  const initialState = {
    remitData: initalRemitData,
    isOutpatient: false,
    claimType: null,
    expandcollaplseButtonTitle: expandcollapseTitles.EXPAND_ALL,
    selectedKeys:[],
    totalPaidAmount: 0,
    caseDetailId: 0,
    varToUpdate:'',
  }

  const RemitDetailReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
      case TOGGLE_REMIT_DETAIL_POPUP:
      case SET_EXPAND_COLLAPSE_BUTTON_TITLE:
      case SET_REMIT_DETAIL_DATA:
        newState = cloneDeepWith(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          newState = { ...newState, ...action.data };
        }
        return newState;
      case ADD_SELECTED_IDS_FROM_CASE_PAY_LINES: {
        const { selectedKeys, selectedRows } = action.data;
      
        const newTotal = selectedRows.reduce((sum, row) => sum + parseDollarAmount(row.providerPayment), 0);
      
        return {
          ...state,
          selectedKeys: [...selectedKeys],
          totalPaidAmount: newTotal,
        };
      }
      case asyncTypes.OPERATION:
      case asyncTypes.COMPLETE:
      case asyncTypes.FAILURE:
        if (isAsyncOperation(GET_REMIT_DETAIL)(action)) {
          return {
            ...state,
            remitData: initalRemitData,
            claimLevelAdjusmentList: [],
            claimLevelRemarksCodeList: [],
            linelevelAdjustmentList: [],
          };
        }
        if (isAsyncComplete(GET_REMIT_DETAIL)(action)) {
          const response = action.response;
          return {
            ...state,
            remitData: response,
            claimLevelAdjusmentList: response.claimLevelAdjustReasonList,
            claimLevelRemarksCodeList: response.claimLevelRemarksCodeList,
            linelevelAdjustmentList: response.linelevelAdjustmentList,
          };
        }
        if (isAsyncOperation(GET_SELECTED_CASE_PAY_LINES)(action)) {
          return {
            ...state,
          };
        }
        if (isAsyncComplete(GET_SELECTED_CASE_PAY_LINES)(action)) {
          return {
            ...state,
            selectedKeys: action.response
          };
        }
        return state;
      default:
        return state;
    }
  }
  
  export default RemitDetailReducer;

  function parseDollarAmount(value) {
    if (typeof value === 'number') return Math.abs(value);
  
    if (typeof value === 'string') {
      let isNegative = false;
      if (value.includes('(') && value.includes(')')) {
        isNegative = true;
        value = value.replace(/[()]/g, ''); 
      }
      const cleaned = value.replace(/[$,]/g, '').trim();
      const parsed = parseFloat(cleaned);
  
      if (isNaN(parsed)) return 0;
  
      return Math.abs(parsed); 
    }
  
    return 0;
  }
  
  export function getRemitSelectionListProperty(varToUpdate) {
    if (!varToUpdate || typeof varToUpdate !== "string") return null;
  
    const lower = varToUpdate.toLowerCase();
  
    if (lower.includes("risk")) return "selectedForRisk";
    if (lower.includes("refund")) return "selectedForTotalRefund";
    if (lower.includes("retained")) return "selectedForTotalRetained";
  
    return null; 
  } 
  